import { connect } from "react-redux";
import Component from "./Footer";
export default connect(
      ({ auth: { loggedIn } }) => ({ loggedIn }),
      ({ auth: { logout } }) => ({ logout })
)(Component);
